.datePicker {
  display: flex;
  flex-direction: column;
}

.label {
  display: block;
  font-size: var(--tuna-typography-fontSize-xs);
  color: var(--tuna-palette-text-secondary);
  margin-bottom: 4px;
}

.input {
  font: inherit;
  padding: 8px 12px;
  border: 1px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-borderRadius);
  background-color: var(--tuna-palette-background-paper);
  color: var(--tuna-palette-text-primary);
  width: 100%;
  box-sizing: border-box;
  transition: border-color var(--tuna-transitions-duration-shorter) var(--tuna-transitions-easing-easeInOut);
}

.input:hover {
  border-color: var(--tuna-palette-text-primary);
}

.input:focus {
  border-color: var(--tuna-palette-primary-main);
  border-width: 2px;
  padding: 7px 11px;
  outline: none;
}

.input:disabled {
  color: var(--tuna-palette-text-disabled);
  cursor: default;
}
